import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client/core'
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'

const client = new ApolloClient({
  link: ApolloLink.from([
    createUploadLink({
      uri: '/graphql'
    })
  ]),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only' // Disable cache to avoid handling cache evict complexity
    }
  }
})

export default client
